import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import * as generic from '../../../components/Generico';
import { ClientePJService } from '../../../service/ClientePJService';
import { InputComponent } from '../../../components/InputComponent';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { PepCpj } from '../../../models/cpj/PepCpj';
import { Divider } from 'primereact/divider';
import { PepAfinidad } from '../common/PepAfinidad';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const PepPj = ({ toast, back, next, id, permss, catalogos, soloLectura }) => {

  const omodel = new PepCpj();
  const defaultValues = generic.funDefault(omodel.model);
  const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues });
  const clientepjSrv = new ClientePJService();
  const [esPep, setEsPep] = useState(false);
  const [relacionPep, setRelacionPep] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const { inText, inCalendar, inDrop } = InputComponent({ omodel, errors, control, permss, id, soloLectura });

  useEffect(() => {
    editFicha();
    // eslint-disable-next-line
  }, [id])

  const editFicha = () => {
    setIsLoading(true);
    clientepjSrv.consultarClientepj(id, 'p5').then(res => {
      const _clientepj = res.data.clientepj;
      _clientepj.fecha_nombramiento_pep = generic.stringToDate(_clientepj.fecha_nombramiento_pep);
      _clientepj.fecha_dejo_pep = generic.stringToDate(_clientepj.fecha_dejo_pep);
      _clientepj.fecha_vinculo_pep = generic.stringToDate(_clientepj.fecha_vinculo_pep);
      _clientepj.fecha_culminacion_vinculo_pep = generic.stringToDate(_clientepj.fecha_culminacion_vinculo_pep);
      setEsPep(_clientepj.pep?.cat_id === true);
      setRelacionPep(_clientepj.relacion_pep?.cat_id === true);

      reset(generic.renewValues(_clientepj, omodel.model));
    }).finally(() => setIsLoading(false));
  }

  const onSubmit = (data) => {
    setIsSaving(true);
    data.paso = 'p5';
    data.id = id;
    if (esPep) {
      data.fecha_nombramiento_pep = data.fecha_nombramiento_pep.toISOString().split('T')[0];
      if (data.fecha_dejo_pep) {
        data.fecha_dejo_pep = data.fecha_dejo_pep.toISOString().split('T')[0];
      }
    }
    if (relacionPep) {
      data.fecha_vinculo_pep = data.fecha_vinculo_pep.toISOString().split('T')[0];
      if (data.fecha_culminacion_vinculo_pep) {
        data.fecha_culminacion_vinculo_pep = data.fecha_culminacion_vinculo_pep.toISOString().split('T')[0];
      }
    }
    clientepjSrv.editarClientepj(data).then(res => {
      generic.funcSuccess(res, toast);
      next(id);
    }).catch(error => {
      generic.funcError(error, toast, setError);
    }).finally(() => setIsSaving(false));
  }

  const onChangePep = (e, esCampoPep) => {
    if (esCampoPep) {
      setEsPep(e.value?.cat_id);
      setValue('nombre_pep', '');
      setValue('cargo_pep', '');
      setValue('institucion_trabaja_pep', '');
      setValue('fecha_nombramiento_pep', null);
      setValue('fecha_dejo_pep', null);
    } else {
      setRelacionPep(e.value?.cat_id);
      setValue('vinculo_pep', '');
      setValue('nombre_vinculo_pep', '');
      setValue('cargo_vinculo_pep', '');
      setValue('institucion_vinculo_pep', '');
      setValue('fecha_vinculo_pep', null);
      setValue('fecha_culminacion_vinculo_pep', null);
    }
  }

  const onError = () => {
    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
  }

  if (isLoading) {
    return (
      <div className="flex flex-column align-items-center justify-content-center p-5">
        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
        <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
      </div>
    );
  }

  return (
    <>
      <form id="pepPjForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
        <Panel header={generic.renderPanelHeader('A.7', 'PERSONA EXPUESTA POLÍTICAMENTE (PEP)', 'pi pi-shield')} className="panel-ficha shadow-1 mb-4">
          <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
            <div className="flex align-items-center gap-2 mb-3">
              <i className="pi pi-info-circle text-blue-600 text-lg"></i>
              <span className="font-bold text-blue-900">Definición de PEP</span>
            </div>
            {omodel.strPep}
          </div>
          <Divider />

          <div className="col-12 mb-3 mt-3">
            <div className="flex align-items-center">
              <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                <i className="pi pi-user text-primary"></i>
                CONDICIÓN DE PEP
              </span>
              <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
            </div>
          </div>

          <div className="formgrid grid">
            {inDrop('pep', generic.estadosSiNo, { lab: omodel.optionLabel, chn: onChangePep, val: true }, 12)}

            {esPep && (
              <>
                {inText('nombre_pep', { icon: 'pi pi-user' }, 6)}
                {inText('cargo_pep', { icon: 'pi pi-briefcase' }, 6)}
                {inText('institucion_trabaja_pep', { icon: 'pi pi-building' }, 12)}
                {inCalendar('fecha_nombramiento_pep', {}, 6)}
                {inCalendar('fecha_dejo_pep', {}, 6)}
              </>
            )}
          </div>

          <div className="col-12 mb-3">
            <div className="flex align-items-center">
              <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                <i className="pi pi-users text-primary"></i>
                FAMILIARES O RELACIONADOS
              </span>
              <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
            </div>
          </div>

          <PepAfinidad tipo='clientepj' id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />

          <div className="col-12 mt-5 mb-3">
            <div className="flex align-items-center">
              <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                <i className="pi pi-share-alt text-primary"></i>
                VÍNCULO CON UN PEP
              </span>
              <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
            </div>
          </div>

          <div className="formgrid grid">
            {inDrop('relacion_pep', generic.estadosSiNo, { lab: omodel.optionLabel, chn: onChangePep, val: false }, 12)}

            {relacionPep && (
              <>
                {inText('vinculo_pep', { icon: 'pi pi-link' }, 6)}
                {inText('nombre_vinculo_pep', { icon: 'pi pi-user' }, 6)}
                {inText('cargo_vinculo_pep', { icon: 'pi pi-briefcase' }, 6)}
                {inText('institucion_vinculo_pep', { icon: 'pi pi-building' }, 6)}
                {inCalendar('fecha_vinculo_pep', {}, 6)}
                {inCalendar('fecha_culminacion_vinculo_pep', {}, 6)}
              </>
            )}
          </div>
        </Panel>

        <BottomActionBar onPrev={back} onNext={next} formId="pepPjForm" loading={isSaving} isReadOnly={soloLectura} />
      </form>
    </>
  );
}
